import { Spinner } from "tamagui";
import { colors } from "@styles/colors";

const InlineLoading = () => {
  return <Spinner size="small" color={colors.subTitleGray} />;
};

export default InlineLoading;
